import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useSavePlace } from './_requests/savePlace'
import Form from '../../../packages/kiti/components/form/form/Form'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import FieldsSection from './sections/FieldsSection'
import LevelsSection from './sections/LevelsSection'
import GeneralSection from './sections/GeneralSection'
import { usePlaceFormattedFormData } from './_helpers/formatPlaceFormData'

const EditPlaceForm = () => {
  const { initialState } = useModalData() || {}
  const place = usePlaceFormattedFormData()

  const [onSubmit, { loading, error }] = useSavePlace()

  return (
    <Form loading={loading} onSubmit={onSubmit} initialState={place || { type: 'location', ...initialState }}>
      <GeneralSection />
      <LevelsSection />
      <FieldsSection />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default EditPlaceForm
